<template>
  <div v-if="domain">
    <DefaultLogin v-if="login == 1" />
    <LoginFloat v-else />
  </div>
  <div v-else>

  </div >

</template>

<script>

export default {
    components: {
        DefaultLogin: () => import("@pages/Login/Default"),
        LoginFloat: () => import("@pages/Login/LoginFloat"),
    },
    data() {
      return {
        login: 1,
        domain: null
      }
    },
    mounted() {
      this.domain = JSON.parse(localStorage.getItem('@datadrive:domain'))

      if(!this.domain){
        location.reload();
      } else {
        this.login = this.domain.entityLayoutID;
      }
    }
}
</script>
